/**
 * @file
 * A JavaScript file containing the search functionality.
 */

(function ($, Drupal) {
    Drupal.behaviors.search = {
        attach: function (context) {
            $('#block-searchform-2').on(
                'click',
                function () {
                    $('#block-searchform-2 .form-search').show();
                    $('#block-searchform-2 .form-search').focus();
                }
            );
            $('#block-searchform-2 .form-search').on(
                'blur',
                function () {
                    $('#block-searchform-2 .form-search').hide();
                }
            );
        }
    };
})(jQuery, Drupal);
